import React from 'react'
import styled from 'styled-components'

import GlobalWrapper from 'components/global-wrapper'
import media from 'utils/media-queries'

import Header from 'components/article/header'
import ContentWrapper from 'components/article/contentwrapper'
import Footer from 'components/footer'
import FullSizeImage from 'components/article/fullsizeimage'

import gtocResultGif from 'img/articles/gtocx/gtocxresult.gif'

const Section = styled.section`
  margin: 64px 0;
  ${media.sm`
    margin: 0;
  `}
`

const EmbedContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  width: 100%;
  height: auto;
  margin-top: 32px;
  margin-bottom: 32px;
  @media (min-width: 1000px) {
    width: 1000px;
    height: 562px;
    padding-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
  }
`

const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const ImageGrid = styled.div`
  background: #f2f2f2;
  max-width: 100%;
  padding: 40px;
  margin: 32px 0;
  text-align: center;
  ${media.lg`
    padding: 32px;
    margin: 0 0 24px 0;
  `}
  ${media.md`
    margin: 0;
    margin: 0 0 16px 0;
  `}
  ${media.sm`
    padding: 16px;
  `}
`

const Img = styled.img`
  max-width: calc(100% - 96px);
  max-height: 300px;
  margin: 8px;
  display: inline-block;
  ${media.xl`
    max-height: 240px;
  `}
  ${media.lg`
    max-height: 200px;
  `}
  ${media.md`
    max-height: 120px;
    margin: 4px;
  `}
  ${media.sm`
    max-height: 80px;
    margin: 2px;
  `}
`

const IBike = () => {
  return (
    <GlobalWrapper>
      <Header title="Autonomous Two wheeler" />
      {/* <CoverImage src={CoverSrc} focusX={'35%'} focusY={'50%'} /> */}
      <Section>
        <ContentWrapper>
          <h3>What is iBike ?</h3>
          <p>
             
          </p>
        </ContentWrapper>
        <EmbedContainer>
          <Video
            width="850"
            height="478"
            src="https://www.youtube.com/embed/5BMgS4Vz7xU?rel=0&amp;showinfo=0"
            frameBorder="0"
            allowFullScreen
          />
        </EmbedContainer>
      </Section>
      <Footer />
    </GlobalWrapper>
  )
}

export default IBike
